import React, { useEffect, useRef, useState } from "react";
import Icon1 from "../icons/Icon";
import CheckBoxGrey from "../textfields/CheckBoxGrey";

function DropDownGPTM3({
  label,
  items = [],
  value = [],
  onChange,
  className,
  disabled = false,
  mandatory = false,
  maxHeight = "300px",
}) {
  const [query, setQuery] = useState("");
  const [isOpen, setIsOpen] = useState(false);

  // Filter items based on the input query
  const filteredItems = items.filter((item) =>
    item.label.toLowerCase().includes(query.toLowerCase())
  );

  const handleSelect = (selectedItem) => {
    const isSelected = value.some((item) => item === selectedItem.value);
    const newSelectedItems = isSelected
      ? value.filter((item) => item !== selectedItem.value)
      : [...value, selectedItem.value];
    onChange(newSelectedItems);
  };

  const dropdownRef = useRef(null);
  const [openUpwards, setOpenUpwards] = useState(null);
  useEffect(() => {
    if (isOpen && dropdownRef.current) {
      const rect = dropdownRef.current.getBoundingClientRect();
      const spaceBelow = window.innerHeight - rect.bottom;
      const spaceAbove = rect.top;

      // If there's more space above than below, open upwards
      setOpenUpwards(spaceAbove > spaceBelow);
    }
  }, [isOpen]);

  let has_value =
    value !== null && value !== undefined && value !== "" && value?.length > 0;

  return (
    <div className={`relative  ${className}`}>
      <div
        onClick={() => setIsOpen(true)}
        className={`relative  select-none     outline-none
  bg-green-200 w-full    flex   ${has_value ? "items-end py-1" : "items-center py-1"}    h-11 rounded-xl shadow-sm ${disabled ? disabled_classname : value ? "bg-white" : "bg-transparent"} 
       } sm:text-sm  ${isOpen || disabled ? "cursor-default" : "cursor-pointer"}  ${!disabled && isOpen ? "border-2 outline-1 outline-blue-100 border-blue-300 " : mandatory && !has_value ? "border-red-300 border-2 outline-1 outline-red-100" : "border    "} `}
        onFocus={() => setIsOpen(true)}
        onBlur={() => setIsOpen(false)}
      >
        {has_value && (
          <div className={`absolute top-0 px-2 text-h6 text-gray-300 `}>
            {label}
          </div>
        )}
        {!isOpen && (
          <div className={`absolute top-1/3 right-3 `}>
            <Icon1 icon_name="down" size={15} fill="grey" />
          </div>
        )}{" "}
        {isOpen && (
          <div className={`absolute top-1/3 right-3 `}>
            <Icon1 icon_name="up" size={15} fill="grey" />
          </div>
        )}{" "}
        <input
          ref={dropdownRef}
          type="text"
          className={`w-full bg-transparent cursor-pointer  rounded-xl  px-2  outline-none transition ease-in-out duration-150 `}
          placeholder={label}
          value={items
            .filter((item) => value.some((selected) => selected === item.value))
            .map((item) => item.label)
            .join(", ")}
          onChange={(e) => setQuery(e.target.value)}
          readOnly // Make the input read-only to prevent typing
        />
        {isOpen && !disabled && (
          <ul
            className={`absolute z-50 w-full  flex flex-col gap-1 p-2 border-1 border-shadow_10 bg-white shadow-xl  h-auto rounded-lg  text-base ring-black ring-opacity-5 overflow-auto focus:outline-none sm:text-sm  ${openUpwards ? "bottom-full mb-1" : "top-full mt-1"}`}
            style={{
              // min bewteen fit content and 300px
              maxHeight: maxHeight, // Adjust height based on number of items
            }}
          >
            {filteredItems.map((item) => (
              <li
                key={item.value}
                className={`cursor-pointer rounded-lg select-none relative py-2 pl-3 pr-9 ${
                  value.some((selected) => selected === item.value)
                    ? "bg-indigo-50 text-indigo-500 font-semibold "
                    : "text-gray-900 hover:bg-indigo-25"
                }`}
                onMouseDown={(e) => e.preventDefault()}
                onClick={() => handleSelect(item)}
              >
                <div className="flex items-center">
                  <CheckBoxGrey
                    checked={value.some((selected) => selected === item.value)}
                    onChange={() => handleSelect(item)}
                  />
                  <span className="ml-3 block truncate">{item.label}</span>
                </div>
              </li>
            ))}
            {filteredItems.length === 0 && (
              <li className="cursor-default select-none relative py-2 pl-3 pr-9 text-gray-500">
                Aucun résultat
              </li>
            )}
          </ul>
        )}{" "}
      </div>
      {isOpen && (
        <div
          onClick={() => setIsOpen(false)}
          className={`fixed cursor-pointer w-screen h-screen top-0 left-0  z-40`}
        ></div>
      )}
    </div>
  );
}

export default DropDownGPTM3;
